/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    Draft,
    DraftFromJSON,
    DraftToJSON,
    PatchedDraft,
    PatchedDraftFromJSON,
    PatchedDraftToJSON,
    Snapshot,
    SnapshotFromJSON,
    SnapshotToJSON,
} from '../models';

export interface CreateSnapshotRequest {
    dealId: string;
    draftKey: string;
    draft?: Draft;
}

export interface ExportNotarialRecordRequest {
    dealId: number;
}

export interface ListDraftsRequest {
    dealId: string;
    ordering?: string;
}

export interface ListSnapshotsRequest {
    dealId: string;
    ordering?: string;
}

export interface PartialUpdateDraftRequest {
    dealId: string;
    draftKey: string;
    patchedDraft?: PatchedDraft;
}

export interface PdfSnapshotRequest {
    dealId: string;
    draftKey: string;
    snapshotId: string;
}

export interface PreviewDraftRequest {
    dealId: number;
    draftKey: string;
}

export interface PreviewSnapshotRequest {
    dealId: string;
    draftKey: string;
    snapshotId: string;
}

export interface UpdateDraftRequest {
    dealId: string;
    draftKey: string;
    draft?: Draft;
}

/**
 * ContractsApi - interface
 * 
 * @export
 * @interface ContractsApiInterface
 */
export interface ContractsApiInterface {
    /**
     * Create a snapshot of contract document draft. Snapshot is immutable and everytime this operation is called a new snapshot is created. It is usually called when draft is approved by all interested departments in the process of contract document completion.
     * @param {string} dealId 
     * @param {string} draftKey 
     * @param {Draft} [draft] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    createSnapshotRaw(requestParameters: CreateSnapshotRequest): Promise<runtime.ApiResponse<void>>;

    /**
     * Create a snapshot of contract document draft. Snapshot is immutable and everytime this operation is called a new snapshot is created. It is usually called when draft is approved by all interested departments in the process of contract document completion.
     */
    createSnapshot(requestParameters: CreateSnapshotRequest): Promise<void>;

    /**
     * 
     * @param {number} dealId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    exportNotarialRecordRaw(requestParameters: ExportNotarialRecordRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    exportNotarialRecord(requestParameters: ExportNotarialRecordRequest): Promise<Blob>;

    /**
     * Listing contract drafts is special in a way that it creates
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    listDraftsRaw(requestParameters: ListDraftsRequest): Promise<runtime.ApiResponse<Array<Draft>>>;

    /**
     * Listing contract drafts is special in a way that it creates
     */
    listDrafts(requestParameters: ListDraftsRequest): Promise<Array<Draft>>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} [ordering] Which field to use when ordering the results.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    listSnapshotsRaw(requestParameters: ListSnapshotsRequest): Promise<runtime.ApiResponse<Array<Snapshot>>>;

    /**
     */
    listSnapshots(requestParameters: ListSnapshotsRequest): Promise<Array<Snapshot>>;

    /**
     * Update contract document draft parameters. Parameters are specific per document type.  Not all applicable contract document drafts are eligible for every deal. It depends on business case. By toggling generate flag, we are enabling snapshot creation.
     * @param {string} dealId 
     * @param {string} draftKey 
     * @param {PatchedDraft} [patchedDraft] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    partialUpdateDraftRaw(requestParameters: PartialUpdateDraftRequest): Promise<runtime.ApiResponse<Draft>>;

    /**
     * Update contract document draft parameters. Parameters are specific per document type.  Not all applicable contract document drafts are eligible for every deal. It depends on business case. By toggling generate flag, we are enabling snapshot creation.
     */
    partialUpdateDraft(requestParameters: PartialUpdateDraftRequest): Promise<Draft>;

    /**
     * 
     * @param {string} dealId 
     * @param {string} draftKey 
     * @param {string} snapshotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    pdfSnapshotRaw(requestParameters: PdfSnapshotRequest): Promise<runtime.ApiResponse<Blob>>;

    /**
     */
    pdfSnapshot(requestParameters: PdfSnapshotRequest): Promise<Blob>;

    /**
     * Preview contract document draft.
     * @param {number} dealId 
     * @param {string} draftKey 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    previewDraftRaw(requestParameters: PreviewDraftRequest): Promise<runtime.ApiResponse<string>>;

    /**
     * Preview contract document draft.
     */
    previewDraft(requestParameters: PreviewDraftRequest): Promise<string>;

    /**
     * Preview snapshot of a contract document. It serves for final revision before printing PDF contracts.
     * @param {string} dealId 
     * @param {string} draftKey 
     * @param {string} snapshotId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    previewSnapshotRaw(requestParameters: PreviewSnapshotRequest): Promise<runtime.ApiResponse<Draft>>;

    /**
     * Preview snapshot of a contract document. It serves for final revision before printing PDF contracts.
     */
    previewSnapshot(requestParameters: PreviewSnapshotRequest): Promise<Draft>;

    /**
     * Update contract document draft parameters. Parameters are specific per document type.  Not all applicable contract document drafts are eligible for every deal. It depends on business case. By toggling generate flag, we are enabling snapshot creation.
     * @param {string} dealId 
     * @param {string} draftKey 
     * @param {Draft} [draft] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ContractsApiInterface
     */
    updateDraftRaw(requestParameters: UpdateDraftRequest): Promise<runtime.ApiResponse<Draft>>;

    /**
     * Update contract document draft parameters. Parameters are specific per document type.  Not all applicable contract document drafts are eligible for every deal. It depends on business case. By toggling generate flag, we are enabling snapshot creation.
     */
    updateDraft(requestParameters: UpdateDraftRequest): Promise<Draft>;

}

/**
 * 
 */
export class ContractsApi extends runtime.BaseAPI implements ContractsApiInterface {

    /**
     * Create a snapshot of contract document draft. Snapshot is immutable and everytime this operation is called a new snapshot is created. It is usually called when draft is approved by all interested departments in the process of contract document completion.
     */
    async createSnapshotRaw(requestParameters: CreateSnapshotRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling createSnapshot.');
        }

        if (requestParameters.draftKey === null || requestParameters.draftKey === undefined) {
            throw new runtime.RequiredError('draftKey','Required parameter requestParameters.draftKey was null or undefined when calling createSnapshot.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/drafts/{draftKey}/snapshots/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"draftKey"}}`, encodeURIComponent(String(requestParameters.draftKey))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: DraftToJSON(requestParameters.draft),
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Create a snapshot of contract document draft. Snapshot is immutable and everytime this operation is called a new snapshot is created. It is usually called when draft is approved by all interested departments in the process of contract document completion.
     */
    async createSnapshot(requestParameters: CreateSnapshotRequest): Promise<void> {
        await this.createSnapshotRaw(requestParameters);
    }

    /**
     */
    async exportNotarialRecordRaw(requestParameters: ExportNotarialRecordRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling exportNotarialRecord.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/drafts/notarial-record/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async exportNotarialRecord(requestParameters: ExportNotarialRecordRequest): Promise<Blob> {
        const response = await this.exportNotarialRecordRaw(requestParameters);
        return await response.value();
    }

    /**
     * Listing contract drafts is special in a way that it creates
     */
    async listDraftsRaw(requestParameters: ListDraftsRequest): Promise<runtime.ApiResponse<Array<Draft>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listDrafts.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/drafts/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(DraftFromJSON));
    }

    /**
     * Listing contract drafts is special in a way that it creates
     */
    async listDrafts(requestParameters: ListDraftsRequest): Promise<Array<Draft>> {
        const response = await this.listDraftsRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async listSnapshotsRaw(requestParameters: ListSnapshotsRequest): Promise<runtime.ApiResponse<Array<Snapshot>>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling listSnapshots.');
        }

        const queryParameters: any = {};

        if (requestParameters.ordering !== undefined) {
            queryParameters['ordering'] = requestParameters.ordering;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/snapshots/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SnapshotFromJSON));
    }

    /**
     */
    async listSnapshots(requestParameters: ListSnapshotsRequest): Promise<Array<Snapshot>> {
        const response = await this.listSnapshotsRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update contract document draft parameters. Parameters are specific per document type.  Not all applicable contract document drafts are eligible for every deal. It depends on business case. By toggling generate flag, we are enabling snapshot creation.
     */
    async partialUpdateDraftRaw(requestParameters: PartialUpdateDraftRequest): Promise<runtime.ApiResponse<Draft>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling partialUpdateDraft.');
        }

        if (requestParameters.draftKey === null || requestParameters.draftKey === undefined) {
            throw new runtime.RequiredError('draftKey','Required parameter requestParameters.draftKey was null or undefined when calling partialUpdateDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/drafts/{draftKey}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"draftKey"}}`, encodeURIComponent(String(requestParameters.draftKey))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedDraftToJSON(requestParameters.patchedDraft),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DraftFromJSON(jsonValue));
    }

    /**
     * Update contract document draft parameters. Parameters are specific per document type.  Not all applicable contract document drafts are eligible for every deal. It depends on business case. By toggling generate flag, we are enabling snapshot creation.
     */
    async partialUpdateDraft(requestParameters: PartialUpdateDraftRequest): Promise<Draft> {
        const response = await this.partialUpdateDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async pdfSnapshotRaw(requestParameters: PdfSnapshotRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling pdfSnapshot.');
        }

        if (requestParameters.draftKey === null || requestParameters.draftKey === undefined) {
            throw new runtime.RequiredError('draftKey','Required parameter requestParameters.draftKey was null or undefined when calling pdfSnapshot.');
        }

        if (requestParameters.snapshotId === null || requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId','Required parameter requestParameters.snapshotId was null or undefined when calling pdfSnapshot.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/drafts/{draftKey}/snapshots/{snapshotId}/pdf/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"draftKey"}}`, encodeURIComponent(String(requestParameters.draftKey))).replace(`{${"snapshotId"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async pdfSnapshot(requestParameters: PdfSnapshotRequest): Promise<Blob> {
        const response = await this.pdfSnapshotRaw(requestParameters);
        return await response.value();
    }

    /**
     * Preview contract document draft.
     */
    async previewDraftRaw(requestParameters: PreviewDraftRequest): Promise<runtime.ApiResponse<string>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling previewDraft.');
        }

        if (requestParameters.draftKey === null || requestParameters.draftKey === undefined) {
            throw new runtime.RequiredError('draftKey','Required parameter requestParameters.draftKey was null or undefined when calling previewDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/drafts/{draftKey}/preview/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"draftKey"}}`, encodeURIComponent(String(requestParameters.draftKey))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Preview contract document draft.
     */
    async previewDraft(requestParameters: PreviewDraftRequest): Promise<string> {
        const response = await this.previewDraftRaw(requestParameters);
        return await response.value();
    }

    /**
     * Preview snapshot of a contract document. It serves for final revision before printing PDF contracts.
     */
    async previewSnapshotRaw(requestParameters: PreviewSnapshotRequest): Promise<runtime.ApiResponse<Draft>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling previewSnapshot.');
        }

        if (requestParameters.draftKey === null || requestParameters.draftKey === undefined) {
            throw new runtime.RequiredError('draftKey','Required parameter requestParameters.draftKey was null or undefined when calling previewSnapshot.');
        }

        if (requestParameters.snapshotId === null || requestParameters.snapshotId === undefined) {
            throw new runtime.RequiredError('snapshotId','Required parameter requestParameters.snapshotId was null or undefined when calling previewSnapshot.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/drafts/{draftKey}/snapshots/{snapshotId}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"draftKey"}}`, encodeURIComponent(String(requestParameters.draftKey))).replace(`{${"snapshotId"}}`, encodeURIComponent(String(requestParameters.snapshotId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DraftFromJSON(jsonValue));
    }

    /**
     * Preview snapshot of a contract document. It serves for final revision before printing PDF contracts.
     */
    async previewSnapshot(requestParameters: PreviewSnapshotRequest): Promise<Draft> {
        const response = await this.previewSnapshotRaw(requestParameters);
        return await response.value();
    }

    /**
     * Update contract document draft parameters. Parameters are specific per document type.  Not all applicable contract document drafts are eligible for every deal. It depends on business case. By toggling generate flag, we are enabling snapshot creation.
     */
    async updateDraftRaw(requestParameters: UpdateDraftRequest): Promise<runtime.ApiResponse<Draft>> {
        if (requestParameters.dealId === null || requestParameters.dealId === undefined) {
            throw new runtime.RequiredError('dealId','Required parameter requestParameters.dealId was null or undefined when calling updateDraft.');
        }

        if (requestParameters.draftKey === null || requestParameters.draftKey === undefined) {
            throw new runtime.RequiredError('draftKey','Required parameter requestParameters.draftKey was null or undefined when calling updateDraft.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("jwtAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/v1/deals/{dealId}/contracts/drafts/{draftKey}/`.replace(`{${"dealId"}}`, encodeURIComponent(String(requestParameters.dealId))).replace(`{${"draftKey"}}`, encodeURIComponent(String(requestParameters.draftKey))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DraftToJSON(requestParameters.draft),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => DraftFromJSON(jsonValue));
    }

    /**
     * Update contract document draft parameters. Parameters are specific per document type.  Not all applicable contract document drafts are eligible for every deal. It depends on business case. By toggling generate flag, we are enabling snapshot creation.
     */
    async updateDraft(requestParameters: UpdateDraftRequest): Promise<Draft> {
        const response = await this.updateDraftRaw(requestParameters);
        return await response.value();
    }

}
